import React from "react";
import Image from "next/image";
import Link from "next/link";
// import { FaFacebookF } from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";
import { FaLinkedinIn } from "react-icons/fa";

export const Footer = () => {
	return (
		<div className="bg-primary text-white py-16 relative z-30">
			<footer className="hp-container">
				<div className="text-[14px] grid grid-cols-1 lg:grid-cols-12 items-start font-light gap-5">
					<div className="col-span-5">
						<Image alt="Hindustan Power logo" src="/logo-white.svg" width={280} height={140} unoptimized className="-ml-3 -mt-3" style={{ height: "auto", width: "100%", }} />
						<div className="flex gap-4 mt-2">
							<Link href="https://www.linkedin.com/company/hindustan-power1/" className="w-8 h-8 border border-white flex items-center justify-center rounded-full">
								<FaLinkedinIn className="w-4 h-4" />
							</Link>
							<Link href="https://x.com/_hindustanpower" className="w-8 h-8 border border-white flex items-center justify-center rounded-full">
								<FaXTwitter className="w-4 h-4" />
							</Link>
						</div>
					</div>
					<p className="col-span-7 text-[14px] md:text-[16px] xl:text-[18px] ">Hindustan Power is a leading independent power producer, with a diversified portfolio spanning renewable energy, transitional power generation and mining operations, serving the country’s growing energy needs.</p>
				</div>

				<div className="grid grid-cols-2 lg:grid-cols-4 gap-8 border-t border-[#7099F1] pt-12 mt-12">
					{/* Company */}
					<div>
						<h3 className="font-bold text-[14px] md:text-[18px] mb-5">Company</h3>
						<ul className="flex flex-col gap-2 text-[14px] md:text-[16px] xl:text-[18px]">
							<li><Link href="/about">About Us</Link></li>
							<li><Link href="/leadership">Leadership</Link></li>
							<li><Link href="/corporate-governance">Corporate Governance</Link></li>
						</ul>
					</div>

					{/* Our Businesses */}
					<div>
						<h3 className="font-bold text-[14px] md:text-[18px] mb-5">Our Businesses</h3>
						<ul className="flex flex-col gap-2 text-[14px] md:text-[16px] xl:text-[18px]">
							<li><Link href="/business/thermal-power">Transitional Energy</Link></li>
							<li><Link href="/business/renewable">Renewable Energy</Link></li>
							<li><Link href="/business/mining">Mining Operations</Link></li>
							<li><Link href="/business/biofuels">Biofuels</Link></li>
							<li><Link href="/business/battery-storage">Battery Storage</Link></li>
							<li><Link href="/business/critical-minerals">Critical Minerals</Link></li>
						</ul>
					</div>

					{/* Sustainability */}
					<div>
						<h3 className="font-bold text-[14px] md:text-[18px] mb-5">Sustainability</h3>
						<ul className="flex flex-col gap-2 text-[14px] md:text-[16px] xl:text-[18px]">
							<li><Link href="/sustainability">Environment</Link></li>
							<li><Link href="/csr">Community &amp; CSR</Link></li>
						</ul>
					</div>

					{/* Media Center */}
					<div>
						<h3 className="font-bold text-[14px] md:text-[18px] mb-5">Media Center</h3>
						<ul className="flex flex-col gap-2 text-[14px] md:text-[16px] xl:text-[18px]">
							<li><Link href="/awards">Award</Link></li>
							<li><Link href="/media-coverage">Media Coverage</Link></li>
							<li><Link href="/news-release">News Releases</Link></li>
							<li><Link href="/media-kit">Media Kit</Link></li>
							<li><Link href="/thought-leadership">Thought Leadership</Link></li>
						</ul>
					</div>

					{/* Additional Header Links */}
					<div>
						<h3 className="font-bold text-[14px] md:text-[18px] mb-5">Quick Links</h3>
						<ul className="flex flex-col gap-2 text-[14px] md:text-[16px] xl:text-[18px]">
							<li><Link href="/life-at-hindustan-power">Careers</Link></li>
							<li><Link href="/tenders">Tenders</Link></li>
							<li><Link href="/contact-us">Contact</Link></li>
							<li><Link href="/privacy-policy">Privacy Policy</Link></li>
							<li><Link href="/terms-of-use">Terms of Use</Link></li>
						</ul>
					</div>

					{/* Corporate Office */}
					<div>
						<h3 className="font-bold text-[14px] md:text-[18px] mb-5">Corporate Office</h3>
						<ul className="flex flex-col gap-2 text-[14px] md:text-[16px] xl:text-[18px]">
							<li>
								<p className="font-light">239, Okhla Industrial Estate, Phase-III, New Delhi-110 020</p>
							</li>
							<li>
								<Link href="tel:+911147624100" className="underline underline-offset-4">+91 11 4762 4100</Link>
							</li>
							<li>
								<Link href="mailto:connect@hindustanpower.in" className="underline underline-offset-4">connect@hindustanpower.in</Link>
							</li>
						</ul>
					</div>
				</div>

				{/* <div className="grid grid-cols-2 lg:grid-cols-4 gap-8 border-t border-[#7099F1] pt-12 mt-12">
					<div className="">
						<h3 className="font-bold text-[14px] md:text-[18px]  mb-5">Company</h3>
						<ul className="flex flex-col gap-2 text-[14px] md:text-[16px] xl:text-[18px] ">
							<li>
								<Link href="/about">About Us</Link>
							</li>
							<li>
								<Link href="/leadership">Leadership</Link>
							</li>
							<li>
								<Link href="/media-coverage">Media</Link>
							</li>
							<li>
								<Link href="/corporate-governance">Corporate Governance</Link>
							</li>
							<li>
								<Link href="/tenders">Tenders</Link>
							</li>
							<li>
								<Link href="/sustainability">Sustainability</Link>
							</li>
							<li>
								<Link href="/life-at-hindustan-power">Careers</Link>
							</li>
						</ul>
					</div>

					<div className="">
						<h3 className="font-bold text-[14px] md:text-[18px]  mb-5">Businesses</h3>
						<ul className="flex flex-col gap-2 text-[14px] md:text-[16px] xl:text-[18px] ">
							<li>
								<Link href="/business/thermal-power">Transitional Energy</Link>
							</li>
							<li>
								<Link href="/business/renewable">Renewable Energy</Link>
							</li>
							<li>
								<Link href="/business/mining">Mining Operations</Link>
							</li>
						</ul>
					</div>
					<div className="">
						<h3 className="font-bold text-[14px] md:text-[18px]  mb-5">Quick Links</h3>
						<ul className="flex flex-col gap-2 text-[14px] md:text-[16px] xl:text-[18px] ">
							<li>
								<Link href="/privacy-policy">Privacy Policy</Link>
							</li>
							<li>
								<Link href="/terms-of-use">Terms of Use</Link>
							</li>
						</ul>
					</div>

					<div className="">
						<h3 className="font-bold text-[14px] md:text-[18px]  mb-5">Corporate Office</h3>
						<ul className="flex flex-col gap-2 text-[14px] md:text-[16px] xl:text-[18px] ">
							<li>
								<p className="font-light">239, Okhla Industrial Estate, Phase-III, New Delhi-110 020</p>
							</li>
							<li>
								<Link href="tel:+911147624100" className="underline underline-offset-4">+91 11 4762 4100</Link>
							</li>
							<li>
								<Link href="mailto:connect@hindustanpower.in" className="underline underline-offset-4">connect@hindustanpower.in</Link>
							</li>
						</ul>
					</div>
				</div> */}
			</footer>
		</div>
	);
};
